import { Box, Divider, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { CircleCheck } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { ButtonDigited } from "../Button/Button.variants";
import { ModalBasic } from "../ModalBasic";

interface MarkAsCompletedSuccessModalProps {
  onBackToCv: () => void;
  onUploadCertificate: () => void;
  open: boolean;
}

export const MarkAsCompletedSuccessModal: React.FC<MarkAsCompletedSuccessModalProps> = ({
  onBackToCv,
  onUploadCertificate,
  open
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <ModalBasic
      open={ open }
      title={ "" }
      handleClose={ onBackToCv }
      size={ { height: "auto", maxHeight: "90vh", width: { sm: "34rem", xs: "100vw" } } }
      content={
        <Box
          sx={ {
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            gap: "1.5rem",
            textAlign: "center",
            width: "100%"
          } }
        >
          <CircleCheck size={ "3rem" } color={ theme.customColors.textPrimary } />

          <Typography
            variant="h5"
            fontWeight={ 700 }
            color={ theme.customColors.textPrimary }
          >
            { t("mark_completed_success_title") }
          </Typography>

          <Box
            sx={ {
              display: "flex",
              flexDirection: "column",
              gap: "1rem"
            } }
          >
            <Typography
              variant="body1"
              color={ theme.customColors.textPrimary }
            >
              { t("mark_completed_success_message") }
            </Typography>
            <Typography
              variant="body1"
              color={ theme.customColors.textPrimary }
            >
              { t("mark_completed_success_question") }
            </Typography>
          </Box>

          <Divider sx={ { borderColor: theme.customColors.border, width: "100%" } } />

          <Box
            sx={ {
              display: "flex",
              flexWrap: "wrap",
              gap: "1rem",
              justifyContent: "center"
            } }
          >
            <ButtonDigited
              typology="secondary"
              onClick={ onBackToCv }
              text={ t("back_to_formative_cv") }
            />
            <ButtonDigited
              typology="primary"
              onClick={ onUploadCertificate }
              text={ t("file_field") }
            />
          </Box>
        </Box>
      }
    />
  );
};
